export default __webpack_public_path__ + "static/media/36I-102747_-17343_0.9e93c375.jpg";